// extracted by mini-css-extract-plugin
module.exports = {"head":"layout_head__j8U4H"};